module.exports = __webpack_public_path__ + "img/icon_blue_light.c66d0dfd.svg";